function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 9c0-.6.4-1 1-1h46c.6 0 1 .4 1 1s-.4 1-1 1H1a1 1 0 0 1-1-1Z",
  fill: "#EAEEF4"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 18.3,
  y: 15.3,
  width: 36,
  height: 2,
  rx: 1,
  fill: "#EAEEF4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M118 46.9c0-.5.4-.9.9-.9H165c.5 0 .9.4.9.9s-.4.9-.9.9H119a.9.9 0 0 1-.9-1ZM113 52.1c0-.5.4-.9.9-.9H142c.5 0 .9.4.9 1 0 .4-.4.8-.9.8H114a.9.9 0 0 1-.9-.9Z",
  fill: "#EAEEF4"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 79,
  cy: 88.5,
  rx: 60,
  ry: 9.5,
  fill: "#F5F8FA"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 17,
  r: 17,
  fill: "#EAEEF4"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 113.5,
  cy: 31.5,
  r: 11.5,
  fill: "#EAEEF4"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M61 17h46a4 4 0 0 1 4 4v58a4 4 0 0 1-4 4H61V17Z",
  fill: "#00BAFF"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M48 21a4 4 0 0 1 4-4h9v66h-9a4 4 0 0 1-4-4V21Z",
  fill: "url(#a)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M76 56a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v27H76V56Z",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M79 34.5a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0Zm5.6-3v4.1c0 .4.4.8.9.8h3.9c.5 0 .8-.4.8-.8s-.3-.7-.8-.7h-3v-3.4c0-.4-.4-.8-1-.8-.4 0-.8.4-.8.8Z",
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 41.5,
  y1: 50,
  x2: 66.5,
  y2: 54.9,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007CFF"
})));

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 100,
    width: 170,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.5655c0bd.svg";
export { ForwardRef as ReactComponent };